// Coins a given finishing rank earns from a prize distribution. The settlement
// engine stores the distribution keyed by exact rank ("1") or an inclusive
// range ("4-10") → coin amount. Accepts `unknown` and validates the shape so a
// malformed or non-record value (e.g. a legacy array) returns 0 rather than a
// non-number — callers can treat a positive return as "this rank actually won".
export function getPrizeForRank(dist: unknown, rank: number): number {
  if (!dist || typeof dist !== 'object' || Array.isArray(dist)) return 0;
  const record = dist as Record<string, unknown>;

  const exact = record[String(rank)];
  if (typeof exact === 'number') return exact;

  for (const key of Object.keys(record)) {
    const m = key.match(/^(\d+)-(\d+)$/);
    if (m && rank >= parseInt(m[1], 10) && rank <= parseInt(m[2], 10)) {
      const value = record[key];
      return typeof value === 'number' ? value : 0;
    }
  }
  return 0;
}
